import REGEXPS from '@/common/regexp';

export const DEPENDENT_SSN_SECURE_MASK = '***-**-9999';
const SSN_LAST4_LENGTH = 4;

export const getMaskedDependentSsn = (ssn?: string | null) => {
  const last4 = (ssn || '').replace(REGEXPS.ALL_NON_NUMERIC, '').slice(-SSN_LAST4_LENGTH);

  return last4.length === SSN_LAST4_LENGTH ? `***-**-${last4}` : undefined;
};

export const isValidDependentSsn = (ssn?: string) =>
  !ssn || REGEXPS.SSN_WITH_DASHES.test(ssn) || REGEXPS.SSN_MASKED_LAST4.test(ssn);

export const formatDependentSsnToServer = (ssn?: string) =>
  ssn && REGEXPS.SSN_WITH_DASHES.test(ssn) ? { ssn } : {};
